import React from 'react';
import Video from './assets/Casa_De_Las_Medias/video.mp4';
const CasaDeLasMedias = () => {
  return (
    <div className="container">
      <h2>
        ✅ Proyecto: Casa de las Medias – Pamplona 🌞✨{' '}
       
      </h2>
      <p>
                <video controls>
          <source src={Video} type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>

 <span className='highlight'>Tradición y sostenibilidad trabajando juntas: energía solar para un ícono comercial de la ciudad.</span>

<br/><br/>En la Casa de las Medias, uno de los establecimientos más emblemáticos de Pamplona con años de trayectoria y reconocimiento local, instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 14.91 kWp, conformado por 21 paneles solares de 710 W (alta eficiencia) y un inversor central de 15 kW.

<br/><br/>Este sistema permite gestionar de manera estable las cargas eléctricas del negocio <span className='highlight'>iluminación, vitrinas, equipos de cómputo y puntos de venta</span> optimizando el uso de la energía y garantizando un funcionamiento seguro para su operación diaria.

<br/><br />Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico del establecimiento
<br/>✔ Implementar una solución sostenible y responsable con el medio ambiente
<br/>✔ Garantizar un suministro de energía eficiente para sus operaciones comerciales<br/>

<br/>Hoy, la Casa de las Medias genera su propia energía limpia, reduciendo sus costos mensuales de facturación eléctrica y aumentando la eficiencia del negocio. Esta inversión no solo representa ahorro, sino también un paso hacia la modernización de un local tradicional sin perder su esencia.

<br/><br/>Con este proyecto, la Casa de las Medias se convierte en un referente de innovación comercial en Pamplona, demostrando que los negocios con historia también pueden liderar el cambio hacia la sostenibilidad.

<br/><br/> <span className='highlight'>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span>

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación

<br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y evolución empresarial.

      </p>
    </div>
  );
};

export default CasaDeLasMedias;
